// firebase
import db from "@/firebase/init";
// moment
import moment from "moment";
moment.locale("pt-br");

export default async function getMeals(snapshot) {
    let meals = [];
    let snaps = [];
    snapshot.forEach(doc => {
        const snap = {
            id: doc.id,
            data: doc.data()
        };
        snaps.push(snap);
    });
    try {
        for (let i = 0; i < snaps.length; i++) {
            let dishRef = db.collection("dishes").doc(snaps[i].data.chosenDish.id);
            const dish = await dishRef.get();
            const dishData = dish.data();
            let mealName, index;
            if (snaps[i].data.meal === "breakfast") {
                mealName = "Café-da-manhã";
                index = 1;
            } else if (snaps[i].data.meal === "morningSnack") {
                mealName = "Lanche da manhã";
                index = 2;
            } else if (snaps[i].data.meal === "lunch") {
                mealName = "Almoço";
                index = 3;
            } else if (snaps[i].data.meal === "afternoonSnack") {
                mealName = "Lanche da tarde";
                index = 4;
            } else if (snaps[i].data.meal === "dinner") {
                mealName = "Jantar";
                index = 5;
            } else if (snaps[i].data.meal === "supper") {
                mealName = "Ceia";
                index = 6;
            } else {
                //
            }
            const dishRelevantData = {
                index: index,
                mealplanId: snaps[i].id,
                proportion: snaps[i].data.chosenDish.proportion,
                nutritionalInfo: dishData.nutritionalInfo,
                meal: snaps[i].data.meal,
                mealName: mealName,
                namePT: dishData.namePT,
                picture: dishData.picture
            };
            const dishObj = {
                id: dish.id,
                data: dishRelevantData
            };
            meals.push(dishObj);
        }
        meals.sort((a, b) => a.data.index - b.data.index);
    } catch (e) {
        console.log(e);
        this.isLoading = false;
    }
    return meals;
}